import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './layouts/Layout';

// Pages - top-level
import Home from './pages/Home';
import NotFound from './pages/NotFound';

// Solutions
import SolutionsIndex from './pages/SolutionsIndex';

// Case studies
import CaseStudiesIndex from './pages/case-studies/CaseStudiesIndex';

// About
import About from './pages/about/About';
import Management from './pages/about/Management';
import Careers from './pages/about/Careers';

// Resources
import Connections from './pages/resources/Connections';
// Glossary hidden for now - uncomment to restore (also its <Route> below, the nav item, and the Footer link).
// import Glossary from './pages/resources/Glossary';

// Specifications - per-partner EDI spec detail (linked from Connections)
import SpecificationDetail from './pages/specifications/SpecificationDetail';

// Marketing pages
import Compare from './pages/Compare';
import Contact from './pages/Contact';

/**
 * App - top-level router.
 *
 * Using BrowserRouter for clean URLs (e.g. /solutions instead of /#/solutions).
 *
 * Production hosting requirement: the web server must serve index.html for
 * any unmatched route so deep links like /case-studies survive a page refresh.
 *   - Nginx:   `try_files $uri /index.html;`
 *   - Apache:  rewrite all to /index.html (already in CRA's default .htaccess)
 *   - Vercel:  `{ "rewrites": [{ "source": "/(.*)", "destination": "/" }] }`
 *   - Netlify: `public/_redirects` → `/* /index.html 200`
 *
 * The CRA dev server (`npm start`) handles this automatically.
 *
 * All routes nest under the shared <Layout> which provides Header + Footer + ScrollToTop.
 */
function App() {
  return (
    // basename lets the same bundle serve from a sub-path (e.g. /corp-next on
    // db3's IIS). CRA inlines process.env.PUBLIC_URL at build time - it's ""
    // for a root build (→ default "/") and "/corp-next" when built with
    // PUBLIC_URL=/corp-next. So local `serve -s build` at root still works.
    <BrowserRouter basename={process.env.PUBLIC_URL || undefined}>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />

          {/* Solutions - slug route pre-opens that section of the accordion */}
          <Route path="solutions" element={<SolutionsIndex />} />
          <Route path="solutions/:slug" element={<SolutionsIndex />} />

          {/* Case studies - slug route pre-opens that case study */}
          <Route path="case-studies" element={<CaseStudiesIndex />} />
          <Route path="case-studies/:slug" element={<CaseStudiesIndex />} />

          {/* About */}
          <Route path="about" element={<About />} />
          <Route path="about/management" element={<Management />} />
          <Route path="about/careers" element={<Careers />} />

          {/* Resources */}
          <Route path="resources/connections" element={<Connections />} />
          {/* Glossary hidden for now - uncomment to restore (also its import above, the nav item, and the Footer link). */}
          {/* <Route path="resources/glossary" element={<Glossary />} /> */}

          {/* Specifications - per-partner EDI spec detail */}
          <Route path="specifications/:id" element={<SpecificationDetail />} />

          {/* Marketing */}
          <Route path="compare" element={<Compare />} />
          <Route path="contact" element={<Contact />} />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
